import React, { useCallback, useEffect, useState } from "react";
import AddBattery from "./addBattery";
import BatteryHistory from "./batteryHistory";
import { Col, Row } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { getExpiry } from "../../common";
import {
  addEditBatteryLevel,
  deleteBatteryLevel,
  getBatteryLevelsFromAPi,
} from "../../redux/actions/battery-levels";
import { useDispatch } from "react-redux";
import { getUserData } from "../../redux/actions/userdata";
import MyTasks from "../../templates/MyTasks";

const BatteryData = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [userId, setUserId] = useState(null);
  const dispatch = useDispatch();
  const [addBatteryState, setAddBatteryState] = useState(22);
  const [cookies] = useCookies([
    "sustainyou_user_jwt",
    "sustainyou_jwt_issued",
    "sustainyou_jwt_expire",
  ]);

  useEffect(() => {
    let expired = getExpiry("user_data_expire");

    const getAllUserData = async (token) => {
      await dispatch(getUserData(token));
    };

    if (cookies.sustainyou_user_jwt) {
      if (expired) {
        getAllUserData(cookies.sustainyou_user_jwt);
      }
    }
  }, [cookies, dispatch]);

  const getRecords = useCallback(
    async (date = "this-week") => {
      setIsLoading(true);
      // if (cookies.sustainyou_user_jwt) {
      // const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
      // setUserId(jwtDecoded.id);
      if (cookies.sustainyou_user_jwt) {
        await dispatch(
          getBatteryLevelsFromAPi(cookies.sustainyou_user_jwt, date)
        );
      }
      // }
      setIsLoading(false);
    },
    [cookies.sustainyou_user_jwt, dispatch]
  );
  const handleAddBattery = async (id, remarks, battery_level) => {
    if (cookies.sustainyou_user_jwt) {
      // const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
      // setUserId(jwtDecoded.id);
      if (cookies.sustainyou_user_jwt) {
        await dispatch(
          addEditBatteryLevel(
            cookies.sustainyou_user_jwt,
            id,
            remarks,
            battery_level
          )
        );
      }
    }
    setAddBatteryState((st) => st + 1);
  };
  useEffect(() => {
    getRecords();
  }, [getRecords]);
  const handleDeleteRecord = async (id) => {
    if (cookies.sustainyou_user_jwt) {
      await dispatch(deleteBatteryLevel(cookies.sustainyou_user_jwt, id));
    }
  };
  const handleRecordEdit = async (id, remarks, battery_level) => {
    if (cookies.sustainyou_user_jwt) {
      await dispatch(
        addEditBatteryLevel(
          cookies.sustainyou_user_jwt,
          id,
          remarks,
          battery_level
        )
      );
    }
  };

  return (
    <Row>
        <Col xs={12} md={12} lg={window.location.pathname === "/" ? 6 : 4} className={`${window.location.pathname === "/" ? 'mt-3' : ''}`}>
            <AddBattery handleAddBattery={handleAddBattery} />
        </Col>

        {window.location.pathname !== "/" &&
          <Col xs={12} md={12} lg={8}>
            <BatteryHistory
            loading={isLoading}
            handleDeleteRecord={handleDeleteRecord}
            handleRecordEdit={handleRecordEdit}
            userToken={cookies.sustainyou_user_jwt}
            addBatteryState={addBatteryState}
            />
          </Col>
        }

        {window.location.pathname === "/" &&
          <Col xs={12} md={12} lg={6}>
            <div className="bg-white rounded">
              <div className="mt-3" style={{ maxHeight: "480px", overflowY: 'scroll' }}>
                <MyTasks />
              </div>
              
            </div>
            </Col>
        }
        
    </Row>
  );
};
export default BatteryData;
